import { api1C } from './api';

export const load1cSignatories = (params) => {
    return api1C.get(`signatories`, {
        params,
    });
}